import { render, staticRenderFns } from "./HallFames.vue?vue&type=template&id=74aaffc2&scoped=true&"
import script from "./HallFames.vue?vue&type=script&lang=js&"
export * from "./HallFames.vue?vue&type=script&lang=js&"
import style0 from "./HallFames.vue?vue&type=style&index=0&id=74aaffc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aaffc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow,VSlideGroup,VSlideItem,VSpacer})
